









































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { discountStatusMap, freeStatusMap, exitEventsMap } from '../../../types/order-management/dictionaries';
import { exportOrderEnex, queryParkingRecordList } from '../../../api/order-management';
import * as routeNames from '../router-names';
import moment from 'moment';
import Utils from '@root/utils/common';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingReviewImage from '@/components/parking-review-image/index.vue';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import { isShiDaill } from '@root/utils/env';

@Component({
  name: 'ParkingRecordList',
  components: {
    ParkingReviewImage,
    ParkingLotSearch,
    PlateInput
  },
  filters: {
    accountingRulesFillter(tyleVal: string) {
      let type = '';
      switch (tyleVal) {
        case '超时':
          type = '';
          break;
        case '超区':
          type = 'danger';
          break;
        case '超位':
          type = 'primary';
          break;
      }
      return type;
    }
  }
})
export default class ParkingRecordList extends Mixins(TableMixin, TableWidthMixin) {
  //  a-tabs
  private activeKey = '20';
  // 查看图片
  showReviewImgModel: boolean = false;
  // 选中项
  reviewImgModel: Object = {};

  plateInputModel = false;
  reviewModelDate: Object = {};
  // 列表数据
  private tableData: any = [];
  // 合计数据
  private sumRowData: any = [];
  // 是否优惠
  private discountStatusList = Utils.toLabelVal(discountStatusMap);
  //是否免费
  private freeStatusList = Utils.toLabelVal(freeStatusMap);
  private tableRef = null;
  enterClear: boolean = true; //默认入场时间可为空
  exitClear: boolean = true; //默认出场时间可为空
  // 出场方式
  @Getter('dictionaries/orderExitEvent')
  orderExitEvent?: object;
  get exitEventsList() {
    return Utils.toLabelVal(this.orderExitEvent);
  }

  @Getter('dictionaries/orderAuthType')
  orderAuthType?: object;
  get vehicleTypeList() {
    // 车辆类型
    return Utils.toLabelVal(this.orderAuthType);
  }

  // 筛选条件 - 时间选择器
  // 入场时间选择器选中值
  selectEnterDate = '';
  // 出场时间选择器选中值
  selectExitDate = '';

  // private exitEventsList = Utils.toLabelVal(exitEventsMap)
  // 表格loading
  private tableLoading: boolean = false;
  private filterParam: any = {
    parkIds: [], // 车场ID集合,多车场逗号分隔
    plateHead: '', // 车牌号
    plateTail: '', // 车牌号
    enterStartTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 入场开始时间
    enterEndTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 入场结束时间
    exitStartTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 	出场开始时间
    exitEndTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 出场结束时间
    discountStatus: '', // 是否优惠，（00：否，01：是）
    freeStatus: '', //是否免费，（00：否，01：是）
    exitEvents: [], // 出场方式，00：自动放行，01：确认放行，02：收费放行，03：跟车出场，04：清理出场，05：特殊放行，06：被冲出场，07：手动抬杆，多个逗号隔开。
    plate: '',
    pkOrderId: '', //停车订单号
    authType: [], // 出场车辆类型
    enterTimeOrderBy: '',
    parkingTimeOrderBy: '',
    exitTimeOrderBy: '',
    plateMobile: ''
  };

  isshidaill: boolean = isShiDaill;

  activated() {
    if (this.$route.params.plate) {
      this.filterParam.plate = this.$route.params.plate as string;
      if (this.filterParam.plate) {
        this.filterParam.plateHead = this.filterParam.plate.substring(0, 1);
        this.filterParam.plateTail = this.filterParam.plate.substring(1);
        this.filterParam.parkIds = [];
        this.filterParam.enterStartTime = '';
        this.filterParam.enterEndTime = '';
        this.filterParam.exitStartTime = '';
        this.filterParam.exitEndTime = '';
        this.filterParam.discountStatus = '';
        this.filterParam.freeStatus = '';
        this.filterParam.exitEvents = [];
        this.filterParam.pkOrderId = '';
        this.filterParam.authType = [];
        this.filterParam.enterTimeOrderBy = '';
        this.filterParam.parkingTimeOrderBy = '';
        this.filterParam.exitTimeOrderBy = '';
        this.filterParam.plateMobile = '';
      }
      setTimeout(() => {
        this.fetchTableData();
      }, 0);
    }
    if (this.$route.params && this.$route.params.parkStatusList) {
      this.skip = true;
      // this.activeKey = '99'
      // this.clear()
      this.plateInputModel = true;
      this.filterParam = {
        parkIds: [], // 车场ID集合,多车场逗号分隔
        plateHead: '', // 车牌号
        plateTail: '', // 车牌号
        enterStartTime: '', // 入场开始时间
        enterEndTime: '', // 入场结束时间
        exitStartTime: '', // 	出场开始时间
        exitEndTime: '', // 出场结束时间
        discountStatus: '', // 是否优惠，（00：否，01：是）
        freeStatus: '', //是否免费，（00：否，01：是）
        exitEvents: [], // 出场方式，00：自动放行，01：确认放行，02：收费放行，03：跟车出场，04：清理出场，05：特殊放行，06：被冲出场，07：手动抬杆，多个逗号隔开。
        plate: '',
        pkOrderId: '',
        authType: [],
        enterTimeOrderBy: '',
        parkingTimeOrderBy: '',
        exitTimeOrderBy: ''
      };
      this.fetchTableData();
    }
  }
  private async created() {
    if (process.env.NODE_ENV == 'development') {
      // @ts-ignore
      window.PARKING_RECORD_LIST_RECORD = this;
    }
    setTimeout(() => {
      this.fetchTableData();
    }, 0);
  }
  get operateTime() {
    if (this.filterParam.enterEndTime && this.filterParam.enterStartTime) {
      return [
        this.moment(this.filterParam.enterStartTime, 'YYYY-MM-DD'),
        this.moment(this.filterParam.enterEndTime, 'YYYY-MM-DD')
      ];
    } else if (this.filterParam.enterStartTime) {
      return [this.moment(this.filterParam.enterStartTime, 'YYYY-MM-DD')];
    } else {
      return [
        moment(moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00'),
        moment(moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59')
      ];
    }
  }
  isDefaultTime: boolean = false;
  get defaultExitTime() {
    if (this.filterParam.exitStartTime && this.filterParam.exitEndTime) {
      return [
        this.moment(this.filterParam.exitStartTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.exitEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.exitStartTime) {
      return [this.moment(this.filterParam.exitStartTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultExitTime(val: any) {}
  set defaultEnterTime(val: any) {}
  get defaultEnterTime() {
    if (this.filterParam.enterStartTime && this.filterParam.enterEndTime) {
      return [
        this.moment(this.filterParam.enterStartTime, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.enterEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.enterStartTime) {
      return [this.moment(this.filterParam.enterStartTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  /**
   * 搜索
   */
  skip = false;
  private search() {
    this.current = 1;
    this.skip = false;
    this.fetchTableData();
  }
  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }
  private onChangeTabs(val: any) {
    this.current = 1;
    this.fetchTableData();
  }
  clear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList, // 车场ID集合,多车场逗号分隔
      plateHead: '', // 车牌号
      plateTail: '', // 车牌号
      enterStartTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 入场开始时间
      enterEndTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 入场结束时间
      exitStartTime: moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00', // 	出场开始时间
      exitEndTime: moment(new Date()).format('YYYY-MM-DD') + ' 23:59:59', // 出场结束时间
      discountStatus: '', // 是否优惠，（00：否，01：是）
      freeStatus: '', //是否免费，（00：否，01：是）
      exitEvents: [], // 出场方式，00：自动放行，01：确认放行，02：收费放行，03：跟车出场，04：清理出场，05：特殊放行，06：被冲出场，07：手动抬杆，多个逗号隔开。
      plate: '',
      pkOrderId: '',
      authType: [],
      enterTimeOrderBy: '',
      parkingTimeOrderBy: '',
      exitTimeOrderBy: '',
      plateMobile: ''
    };
    this.enterClear = true;
    this.exitClear = true;
    this.search();
  }

  public async fetchTableData() {
    // 出入场时间跨度判断拦截 （单车场可跨365天，多车场最多可跨30天）
    if (
      moment(this.filterParam.exitEndTime).diff(moment(this.filterParam.exitStartTime), 'days') >
      this.exitEnterTimeoffsetDays
    ) {
      this.$message.warn(`查询条件：出场时间，跨度不可超过${this.exitEnterTimeoffsetDays}天`);
      return;
    }
    if (
      moment(this.filterParam.enterEndTime).diff(moment(this.filterParam.enterStartTime), 'days') >
      this.exitEnterTimeoffsetDays
    ) {
      this.$message.warn(`查询条件：入场时间，跨度不可超过${this.exitEnterTimeoffsetDays}天`);
      return;
    }
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const {
        parkIds,
        plateHead,
        plateTail,
        enterStartTime,
        enterEndTime,
        exitStartTime,
        exitEndTime,
        discountStatus,
        freeStatus,
        exitEvents,
        pkOrderId,
        authType,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        exitTimeOrderBy,
        plateMobile
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行查询');
      }
      let forms = {
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        enterStartTime,
        enterEndTime,
        exitStartTime,
        exitEndTime,
        discountStatus,
        freeStatus,
        orderType: this.activeKey === '20' ? '' : this.activeKey,
        exitEvents: '' + exitEvents,
        currPage: this.current,
        pageSize: this.pageSize,
        pkOrderId,
        authType: '' + authType,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        exitTimeOrderBy,
        plateMobile
      };
      if (this.skip) {
        forms = {
          ...forms,
          ...this.$route.params,
          exitStartTime: '',
          exitEndTime: ''
        };
      }
      const { status, msg, code, data } = await queryParkingRecordList({ ...forms });
      if (data) {
        const { pageSize = 0, currPage = 0, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.sumRowData = total;
        if (datas.length > 0) {
          this.tableData = datas.map(item => {
            return {
              ...item,
              enterTimeNum: moment(item.enterTime).valueOf(),
              exitTimeNum: moment(item.exitTime).valueOf()
            };
          });
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryParkingRecordList  接口调用错误');
    } finally {
      this.tableLoading = false;
    }
  }

  exportLoading = false;
  private async download() {
    if (this.exportLoading) return;
    // if (this.total > 50000) {
    //   this.exportLoading = false
    //   return this.$message.error('导出最大只能支持五万条')
    // }
    this.exportLoading = true;
    try {
      const {
        parkIds,
        plateHead,
        plateTail,
        enterStartTime,
        enterEndTime,
        exitStartTime,
        exitEndTime,
        discountStatus,
        freeStatus,
        exitEvents,
        pkOrderId,
        authType,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        exitTimeOrderBy,
        plateMobile
      } = this.filterParam;
      if (plateTail && plateHead === '') {
        return this.$message.error('请先选择省份再进行导出');
      }
      let exportform = {
        parkIds: '' + parkIds,
        plateHead,
        plateTail,
        enterStartTime,
        enterEndTime,
        exitStartTime,
        exitEndTime,
        discountStatus,
        freeStatus,
        authType: '' + authType,
        enterTimeOrderBy,
        parkingTimeOrderBy,
        exitTimeOrderBy,
        exitEvents: '' + exitEvents,
        orderType: this.activeKey === '20' ? '' : this.activeKey
      };
      if (this.skip) {
        exportform = {
          ...exportform,
          ...this.$route.params,
          exitStartTime: '',
          exitEndTime: ''
        };
      }
      await exportOrderEnex(
        {
          ...exportform
        },
        '停车记录'
      );
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.exportLoading = false;
    }
  }

  private moment = moment;

  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  get tableColums() {
    if (this.isshidaill)
      return [
        {
          title: '序号',
          width: 100,
          customRender: (text: any, record: any, index: number) => {
            if (record.isTotal === true) {
              return '';
            }
            return `${(this.current - 1) * this.pageSize + index + 1}`;
          }
        },
        {
          title: '车场名称',
          dataIndex: 'parkName',
          width: 180,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '车牌号',
          dataIndex: 'plate',
          width: 140
        },
        {
          title: '入场时间',
          dataIndex: 'enterTime',
          width: 200
        },
        {
          title: '入场通道',
          dataIndex: 'enterChannelName',
          width: 170,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '出场时间',
          dataIndex: 'exitTime',
          width: 200
        },
        {
          title: '出场通道',
          dataIndex: 'exitChannelName',
          width: 170,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        {
          title: '停车时长',
          dataIndex: 'parkingTime',
          width: 200
        },
        {
          title: '车辆类型',
          dataIndex: 'authTypeName',
          width: 170,
          scopedSlots: { customRender: 'text-ellipse-to-tip' }
        },
        // {
        //   title: '计费类型',
        //   dataIndex: 'feeTypeName',
        //   scopedSlots: { customRender: 'feeTypeName' },
        //   width: 240,
        // },
        {
          title: '应收金额',
          dataIndex: 'totalAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '实收金额',
          dataIndex: 'paidAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '优惠金额',
          dataIndex: 'discountAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '应收未收',
          dataIndex: 'unpaidAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '特殊减免',
          dataIndex: 'specialAmount',
          width: 140,
          customRender: (text: any, record: any, index: number) =>
            Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
        },
        {
          title: '出场方式',
          dataIndex: 'exitEventName',
          width: 140
        },
        {
          title: '停车订单号',
          dataIndex: 'pkOrderId',
          width: 240,
          scopedSlots: { customRender: 'pkOrderId' }
        },
        {
          title: '手机号',
          dataIndex: 'plateMobile',
          width: 140,
          scopedSlots: { customRender: 'pkOrderId' }
        },
        {
          title: '查看图片',
          dataIndex: 'exitImg',
          scopedSlots: { customRender: 'exitImg' },
          fixed: 'right',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          fixed: 'right',
          width: 100
        }
      ];
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        width: 140
      },
      {
        title: '入场时间',
        dataIndex: 'enterTime',
        width: 200
      },
      {
        title: '入场通道',
        dataIndex: 'enterChannelName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '出场时间',
        dataIndex: 'exitTime',
        width: 200
      },
      {
        title: '出场通道',
        dataIndex: 'exitChannelName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      {
        title: '停车时长',
        dataIndex: 'parkingTime',
        width: 200
      },
      {
        title: '车辆类型',
        dataIndex: 'authTypeName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-to-tip' }
      },
      // {
      //   title: '计费类型',
      //   dataIndex: 'feeTypeName',
      //   scopedSlots: { customRender: 'feeTypeName' },
      //   width: 240,
      // },
      {
        title: '应收金额',
        dataIndex: 'totalAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '实收金额',
        dataIndex: 'paidAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '优惠金额',
        dataIndex: 'discountAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '应收未收',
        dataIndex: 'unpaidAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '特殊减免',
        dataIndex: 'specialAmount',
        width: 140,
        customRender: (text: any, record: any, index: number) =>
          Number(text || 0).toFixed(2) ? `￥${Number(text || 0).toFixed(2)}` : '--'
      },
      {
        title: '出场方式',
        dataIndex: 'exitEventName',
        width: 140
      },
      {
        title: '停车订单号',
        dataIndex: 'pkOrderId',
        width: 240,
        scopedSlots: { customRender: 'pkOrderId' }
      },
      {
        title: '查看图片',
        dataIndex: 'exitImg',
        scopedSlots: { customRender: 'exitImg' },
        fixed: 'right',
        width: 100
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 100
      }
    ];
  }

  reviewColums = [
    {
      imageSrc: 'enterImg',
      data: [
        {
          label: '车牌',
          dataIndex: 'plate'
        },
        {
          label: '入场时间',
          dataIndex: 'enterTime'
        },
        {
          label: '入场位置',
          dataIndex: 'enterChannelName'
        }
      ]
    },
    {
      imageSrc: 'exitImg',
      data: [
        {
          label: '车牌',
          dataIndex: 'plate'
        },
        {
          label: '出场时间',
          dataIndex: 'exitTime'
        },
        {
          label: '出场位置',
          dataIndex: 'exitChannelName'
        }
      ]
    }
  ];

  // 出入场时间筛选设置30天范围限制公共方法
  private disabledDateHandle(current: any, selectDate, offsetDays) {
    if (selectDate) {
      return (
        current >
          moment(selectDate)
            .add(offsetDays, 'days')
            .endOf('day') ||
        current <
          moment(selectDate)
            .add(-1 * offsetDays, 'days')
            .endOf('day') ||
        current > moment().endOf('day')
      );
    } else {
      return current > moment().endOf('day');
    }
  }
  // 筛选条件：出入场时间，可选最大跨度 （单车场365天，多车场30天）
  get exitEnterTimeoffsetDays() {
    return this.filterParam.parkIds.length === 1 ? 365 : 30;
  }
  // 入场时间改变
  onEnterTimeCalendarChange(date: any, dateString: any) {
    if (date.length === 1) {
      this.selectEnterDate = date[0];
    }
  }
  onEnterTimeChange(date: any, dateString: any) {
    this.selectEnterDate = '';
    const [enterStartTime, enterEndTime] = dateString;
    this.filterParam.enterEndTime = enterEndTime;
    this.filterParam.enterStartTime = enterStartTime;
    if (enterEndTime && enterStartTime) {
      this.exitClear = true;
    } else {
      this.exitClear = false;
    }
  }
  disabledExitDateHandle(current: any) {
    return this.disabledDateHandle(current, this.selectExitDate, this.exitEnterTimeoffsetDays);
  }
  // 出场时间改变
  onExitTimeCalendarChange(date: any) {
    if (date.length === 1) {
      this.selectExitDate = date[0];
    }
  }
  onExitTimeChange(date: any, dateString: any) {
    this.selectExitDate = '';
    const [exitStartTime, exitEndTime] = dateString;
    this.filterParam.exitEndTime = exitEndTime;
    this.filterParam.exitStartTime = exitStartTime;
    if (exitEndTime && exitStartTime) {
      this.enterClear = true;
    } else {
      this.enterClear = false;
    }
  }
  disabledEnterDateHandle(current: any) {
    return this.disabledDateHandle(current, this.selectEnterDate, this.exitEnterTimeoffsetDays);
  }

  // 跳转到详情
  toDetail(obj: any) {
    this.$router.push({
      name: routeNames.PARKING_RECORD_DETAIL,
      query: {
        pkOrderId: obj.pkOrderId,
        parkId: obj.parkId
      }
    });
  }

  // 查看图片
  reviewImages(record: {}) {
    this.reviewModelDate = record;
    this.showReviewImgModel = true;
  }

  // 表头筛选
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
}
